import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NavParams } from '@ionic/angular';
import { AppConstants } from 'src/app/utilities/constant';

@Component({
  selector: 'app-copy-roadmap',
  templateUrl: './copy-roadmap.component.html',
  styleUrls: ['./copy-roadmap.component.scss'],
})
export class CopyRoadmapComponent implements OnInit {
  public roadmapSections: any; 
  public roadmap: any;
  public roadmapId: string;
  public stepId: string;
  public copiedHazardData = [];
  payload: any = {};
  constructor(private modalController: ModalController, private navParams: NavParams) { }
  
  ngOnInit() {    
    
    this.roadmapId = this.navParams.get('roadmapId');
    this.roadmapSections = this.navParams.get('roadmapSections');
    this.roadmap=this.roadmapSections.map((section: any) => {   
      if (section.hazards && Array.isArray(section.hazards)) {
        section.hazards = section.hazards.map((hazard: any) => ({
          ...hazard,
          isCopied: false
        }));
      }    
      return section;
    });  
  }

  isPayloadEmpty(): boolean {
    return !this.payload || Object.keys(this.payload).length === 0;
  }
  /**
   * Closes copy roadmap component
   */
  public close() {
    this.modalController.dismiss();
  }  

  /**
   * Updates hazard
   * 
   * @param item 
   * @param event 
   */
  
  
  public updateHazard(stepId, hazards: any, item: any, event) {
    hazards.forEach(hazard => {
      if (hazard.hazardId === item.hazardId) {
        hazard.isCopied = !!event;
      }
    });
    
    // Initialize payload object if missing
    if (!this.payload || typeof this.payload !== 'object') {
      this.payload = {
        stepId: '',
        roadmapId: '',
        hazards: []
      };
    }
    
    // Set IDs only once (optional guard)
    this.payload.stepId = this.stepId;
    this.payload.roadmapId = this.roadmapId;
    if (!Array.isArray(this.payload.hazards)) {
      this.payload.hazards = [];
    }
    if (event) {      
      const alreadyExists = this.payload.hazards.some(
        h => h.hazardId === item.hazardId && h.hazardStepId === stepId
      );
    
      if (!alreadyExists) {
        this.payload.hazards.push({
          hazardStepId: stepId,
          hazardId: item.hazardId
        });
      }
    } else {      
      this.payload.hazards = this.payload.hazards.filter(
        h => !(h.hazardId === item.hazardId && h.hazardStepId === stepId)
      );
    }
  }

  /**
   * Opens add hazard
   */
  public openAddHazard() {
    this.modalController.dismiss({ dataType: AppConstants.ADD_HAZARD, copiedHazard: '' });
  }

  /**
   * Adds copied hazard
   */
  public addCopiedHazard() {
    console.log('this.payload', this.payload);
    const data: any = { dataType: AppConstants.COPY_HAZARD, copiedHazard: this.payload }
    this.modalController.dismiss(data);
  }
}
